import React from "react";

type HeyAiIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  strokeWidth?: number;
};

const HeyAiIconBase: React.FC<HeyAiIconProps & { children: React.ReactNode }> = ({
  size = 16,
  strokeWidth = 1.25,
  children,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    {children}
  </svg>
);

export const HeyAiTextIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <path d="M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9l-4 3v-3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" />
    <path d="M8 9h8" />
    <path d="M8 13h6" />
  </HeyAiIconBase>
);

export const HeyAiMicrophoneIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0" />
    <path d="M12 18v3" />
    <path d="M8 21h8" />
  </HeyAiIconBase>
);

export const HeyAiKeyboardIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <rect x="3" y="6" width="18" height="12" rx="2" />
    <path d="M7 10h.01M11 10h.01M15 10h.01M18 10h.01" />
    <path d="M7 14h10" />
  </HeyAiIconBase>
);

export const HeyAiSendIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <path d="M21 3 10 14" />
    <path d="m21 3-7 18-4-7-7-4 18-7z" />
    <path d="m10 14 4 7" />
  </HeyAiIconBase>
);

export const HeyAiSettingsIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.6-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9l-.1-.1A2 2 0 1 1 7.1 4l.1.1a1.7 1.7 0 0 0 1.9.3 1.7 1.7 0 0 0 1-1.6V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1A2 2 0 1 1 19.9 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
  </HeyAiIconBase>
);

export const HeyAiMinimizeIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <path d="M6 12h12" />
  </HeyAiIconBase>
);

export const HeyAiCloseIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <path d="M6 6l12 12" />
    <path d="M18 6 6 18" />
  </HeyAiIconBase>
);

export const HeyAiPlusIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </HeyAiIconBase>
);

// From the HeyAI utility icon set (copy.svg / check.svg, currentColor variants).
export const HeyAiCopyIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <rect x="9" y="8" width="10" height="12" rx="2" />
    <rect x="5" y="4" width="10" height="12" rx="2" />
  </HeyAiIconBase>
);

export const HeyAiCheckIcon: React.FC<HeyAiIconProps> = (props) => (
  <HeyAiIconBase {...props}>
    <path d="m5.5 12.5 4.2 4.2L18.5 8" />
  </HeyAiIconBase>
);
